import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CustomTitle } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-filter-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, DialogModule, ButtonModule, CustomTitle, DropdownModule],
  templateUrl: './filter-dialog.component.html',
  styleUrl: './filter-dialog.component.scss'
})
export class FilterDialogComponent<T> implements OnInit {

  headerText !: string;

  categoryField !: string;
  dataset: T[] = [];

  filterType !: 'dropdown';

  selectedValue !: T | undefined;

  displayDialog = false;
  translations: any = {};

  @Output() onSeleccionar = new EventEmitter<T>();
  @Output() onCancelar = new EventEmitter<any>();

  constructor(private _t: TranslateService) { }

  async ngOnInit() {
    this.translations = await firstValueFrom(forkJoin({
      cancelar: this._t.get('form.button.cancelar'),
      guardar: this._t.get('form.button.guardar'),
      seleccionar: this._t.get('common.seleccionar'),
    }));
  }

  showDialog() {
    this.displayDialog = true;
  }

  hideDialog() {
    this.displayDialog = false;
  }

  setHeaderText(text: string) {
    this.headerText = text;
  }

  InitializeDropdownFilter(labelField: string, dataset: T[]) {
    this.filterType = 'dropdown';
    this.categoryField = labelField;
    this.dataset = dataset;
  }

  handleSeleccionar() {
    this.onSeleccionar.emit(this.selectedValue);
    this.hideDialog();
  }

  handleCancelar() {
    this.onCancelar.emit();
    this.hideDialog();
  }

  resetValue(){
    this.selectedValue = undefined;
  }
}
